import { memo } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import styled from 'styled-components';

const DotsWrapper = styled.div`
	position: relative;
	left: -9999px;
	color: inherit;
`;

const Dots = styled(motion.div)`
	position: absolute;
	top: 0;
	width: 10px;
	height: 10px;
	border-radius: 5px;
	box-shadow: 9999px 0 0 -5px;
	color: inherit;
`;

const DotsBefore = styled(Dots)`
	box-shadow: 9984px 0 0 -5px;
	color: inherit;
`;
const DotsAfter = styled(Dots)`
	box-shadow: 10014px 0 0 -5px;
	color: inherit;
`;
const boxShadowValuesBefore = ['9984px 0 0 -5px', '9984px 0 0 2px', '9984px 0 0 -5px', '9984px 0 0 -5px'];
const boxShadowValues = ['9999px 0 0 -5px', '9999px 0 0 2px', '9999px 0 0 -5px', '9999px 0 0 -5px'];
const boxShadowValuesAfter = ['10014px 0 0 -5px', '10014px 0 0 2px', '10014px 0 0 -5px', '10014px 0 0 -5px'];

const transition = {
	duration: 2,
	ease: 'linear',
	repeat: Infinity,
	times: [0, 0.33, 0.67, 1]
};

const transitionBefore = { ...transition, ...{ delay: 0 } };
const transitionMiddle = { ...transition, ...{ delay: 0.33 } };
const transitionAfter = { ...transition, ...{ delay: 0.67 } };

const MotionDots = motion(Dots);
const MotionDotsBefore = motion(DotsBefore);
const MotionDotsAfter = motion(DotsAfter);

const DotsAnimation = () => (
	<DotsWrapper className="dots-wrapper">
		<AnimatePresence>
			<MotionDotsBefore
				key="before"
				animate={{
					boxShadow: boxShadowValuesBefore
				}}
				transition={transitionBefore}
			/>
			<MotionDots
				key="middle"
				animate={{
					boxShadow: boxShadowValues
				}}
				transition={transitionMiddle}
			/>
			<MotionDotsAfter
				key="after"
				animate={{
					boxShadow: boxShadowValuesAfter
				}}
				transition={transitionAfter}
			/>
		</AnimatePresence>
	</DotsWrapper>
);
const DotsAnimationMemoized = memo(DotsAnimation);
export default DotsAnimationMemoized;
